<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Downloads',

    metaInfo: { title: 'Downloads' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        // 'platform-support',
        // 'customer-reviews',
        // 'we-help-your-success',
        // 'info-graph',
        // 'theme-features',
        // 'affiliates',
        'downloads',
        // 'newsletter',
        'info-alt',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
